import plural from 'plural-ru';

export function formatTrainingDuration(minutes: number) {
  return `${minutes} ${plural(minutes, 'минута', 'минуты', 'минут')}`;
}
